<template>
    <div class="ConfirmLeaveView" v-if="isOpenConfirm">
        <div class="ConfirmLeaveView-wrapper">
            <p>У вас есть несохраненные изменения. Вы уверены, что хотите перейти на другую страницу?</p>
            <div class="ConfirmLeaveView-wrapperButtons">
                <button @click="trigger">Нет</button>
                <button @click="move">Да</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConfirmLeaveView',
    mixins: [mixins.ValidationComponentMixin],
    data() {
        return {
            cancel: Function,
            next: Function,
            isOpenConfirm: false
        };
    },
    mounted() {
        this.$root.$on('confirm-popup', (cancel, next) => {
            this.cancel = cancel;
            this.next = next;

            this.trigger();
        })
    },

    methods: {
        trigger() {
            this.isOpenConfirm = !this.isOpenConfirm
        },

        move() {
            this.trigger();

            this.cancel();
            this.next();
        }
    }
};
</script>

<style scoped lang="less">
@import "~styles/const.less";

@r: .ConfirmLeaveView;

@{r} {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 2000;
    background-color: rgba(@color-black, 0.3);
    padding-left: 220px;
    animation-duration: 0.3s;
    animation-name: confirm;

    @keyframes confirm {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    &-wrapper {
        width: 620px;
        height: 200px;
        margin: 35vh auto;
        background-color: @color-white;
        animation-duration: 0.3s;
        animation-name: confirm-wrapper;
        padding: 63px 20px 20px 20px;

        p {
            font-size: 12px;
            line-height: 14px;
            text-align: center;
            margin-top: 0;
            margin-bottom: 63px;
        }

        &Buttons {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            line-height: 14px;

            button {
                width: 280px;
                height: 40px;
                background-color: @color-black;
                color: @color-white;
                cursor: pointer;
            }
        }

        @keyframes confirm-wrapper {
            from {
                transform: scale(0.1, 0.1);
            }

            to {
                transform: scale(1, 1);
            }
        }
    }
}
</style>
